const fcc = () => import("./fcc.vue");

const fccRoutes = {
  name: "fcc",
  meta: {
    title: "FCC DIGITAL",
    requiresAuth: true,
  },
  component: fcc,
};

export default fccRoutes;
